import {
  DEFAULT_PUBLIC_RUNTIME_CONFIG,
  PublicRuntimeConfig,
  RUNTIME_CONFIG_WINDOW_KEY,
} from "./public-runtime-config.shared";

const readEnv = (key: string): string | undefined => {
  const viteKey = `VITE_${key}`;
  const nextPublicKey = `NEXT_PUBLIC_${key}`;
  const env = import.meta.env as Record<string, string | undefined>;

  return (
    env[viteKey] ??
    env[nextPublicKey] ??
    // Some tooling (like Vitest) still exposes process.env
    (typeof process !== "undefined" ? process.env?.[key] : undefined)
  );
};

const resolveRuntimeConfig = (): PublicRuntimeConfig => ({
  apiUrl: readEnv("API_URL") ?? DEFAULT_PUBLIC_RUNTIME_CONFIG.apiUrl,
  websocketUrl:
    readEnv("WEBSOCKET_URL") ?? DEFAULT_PUBLIC_RUNTIME_CONFIG.websocketUrl,
});

type RuntimeConfigWindow = Window & {
  [RUNTIME_CONFIG_WINDOW_KEY]?: PublicRuntimeConfig;
};

export const initializePublicRuntimeConfig = (): PublicRuntimeConfig => {
  const config = resolveRuntimeConfig();

  if (typeof window !== "undefined") {
    (window as RuntimeConfigWindow)[RUNTIME_CONFIG_WINDOW_KEY] = config;
  }

  return config;
};

export const getPublicRuntimeConfig = (): PublicRuntimeConfig => {
  if (typeof window === "undefined") {
    return resolveRuntimeConfig();
  }

  const runtimeWindow = window as RuntimeConfigWindow;
  let config = runtimeWindow[RUNTIME_CONFIG_WINDOW_KEY];
  if (!config) {
    config = resolveRuntimeConfig();
    runtimeWindow[RUNTIME_CONFIG_WINDOW_KEY] = config;
  }

  return config;
};

export const getEnvValue = (key: string): string | undefined => readEnv(key);
